import * as React       from "react";
import {cx}             from "emotion";
import {Types}          from "@Common/types";
import {cst, cstAssign} from "@Common/react/chain-services";
import {UseState}       from "@Common/react/use-state";
import {ButtonSpinner}  from "@Common/ui-components/loading-spinners/button-spinner";
import "./button.scss";

export const Button = ({
/*  PROPS  ************************************************************************************************************/
    buttonText,
    disabled = false,
    downloadProgressPercent  = 0,
    xdQaName,
    className                = "", // additional class to append to button-hs9
    onClick,
}:{
/*  PROP TYPES  *******************************************************************************************************/
    buttonText               : string | JSX.Element,
    disabled                ?: boolean,
    downloadProgressPercent ?: number,
    xdQaName                 : string,
    className               ?: string,
    onClick                  : (e:React.MouseEvent<HTMLButtonElement>) => Promise<void>,
}) => cst<{
/*  CS ASSIGNMENT NODE TYPES  *****************************************************************************************/
    state                    : Types.Common.React.UseState.UseStateNext<{
        isLoading            : boolean,
    }>,
    isInProgress             : boolean,
}>(

    // set state vars
    cstAssign("state", (_, next) => UseState({
        defaultValue: {
            isLoading: false,
        },
        next,
    })),

    // set in progress status
    cstAssign("isInProgress", (_, next) => next(downloadProgressPercent > 0)),

    // render component
    ({state, isInProgress}) => (
        <button className={cx("button-hs9", className)}
            xd-qa-type="button"
            xd-qa-name={xdQaName}
            disabled={state.value.isLoading || disabled}
            onClick={async (e) => {
                state.onChange({...state.value, isLoading: true});
                await onClick(e);
                state.onChange({...state.value, isLoading: false});
            }}
        >
            {buttonText}
            {state.value.isLoading && <ButtonSpinner/>}
            {isInProgress && (
            <div className={cx("meter", {fakedMeter: downloadProgressPercent > 100})}
                style={{width: (downloadProgressPercent) ? `${downloadProgressPercent}%` : "100%"}}
            />
            )}
        </button>
    )
);
